<template>
  <div class="grid grid-cols-1 gap-4 w-full shrink-0">
    <UFormField label="País onde reside" name="country" size="lg" :error="r$.country?.$error ? r$.country.$errors?.[0] : undefined">
      <USelect v-model="state.country" :items="countryOptions" class="w-full" size="lg" data-cy="register-country-select"
        :color="r$.country?.$dirty ? (r$.country.$correct ? 'success' : 'error') : 'neutral'"
        @blur="r$.country?.$touch()">
        <template #trailing>
          <UIcon v-if="r$.country?.$correct" name="i-lucide-check-circle" class="size-5 text-success shrink-0 me-2" aria-hidden="true" />
        </template>
      </USelect>
    </UFormField>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <UFormField label="Estado" name="state" size="lg" :error="r$.state?.$error ? r$.state.$errors?.[0] : undefined">
        <UInput v-model="state.state" placeholder="Ex.: MG" class="w-full" size="lg" data-cy="register-state-input"
          :color="r$.state?.$dirty ? (r$.state.$correct ? 'success' : 'error') : 'neutral'"
          @blur="r$.state?.$touch()">
          <template #trailing>
            <UIcon v-if="r$.state?.$correct" name="i-lucide-check-circle" class="size-5 text-success shrink-0 me-2" aria-hidden="true" />
          </template>
        </UInput>
      </UFormField>

      <UFormField label="Cidade/Município" name="city" size="lg" :error="r$.city?.$error ? r$.city.$errors?.[0] : undefined">
        <UInput v-model="state.city" placeholder="Cidade onde reside" class="w-full" size="lg" data-cy="register-city-input"
          :color="r$.city?.$dirty ? (r$.city.$correct ? 'success' : 'error') : 'neutral'"
          @blur="r$.city?.$touch()">
          <template #trailing>
            <UIcon v-if="r$.city?.$correct" name="i-lucide-check-circle" class="size-5 text-success shrink-0 me-2" aria-hidden="true" />
          </template>
        </UInput>
      </UFormField>
    </div>
  </div>
</template>

<script setup lang="ts">

const store = useRegisterStore()
const state = store.state

const { r$ } = useRegleSchema(state as any, step2Schema, { autoDirty: true })

defineExpose({
  validate: async () => await r$.$validate(),
  reset: () => r$.$reset()
})
</script>